import { UserPublic } from '@playq/octopus2-auth';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

export const usersServiceProfile: string[] = ['retrieve', 'profile'];

export const useRetrieveProfile = (
  options?: IUseQueryOptionsExtended<UserPublic | undefined, GenericFailure | Error>
) => {
  return useEitherQuery(usersServiceProfile, () => services2.userProfileService.retrieve(), {
    ...options,
  });
};
